import api from "../api";
import {subscribeToChannel, unsubscribeToChannel} from "../services/pusher";

const state = () => ({
  contactId: null,
  communicationLogs: [],
  showMoreCommsButton: true,
  paginationPage: 1,
  paginationSize: 25,
});

const getters = {
  contactId(state) {
    return state.contactId;
  },
  communicationLogs(state) {
    return state.communicationLogs.sort((a,b) => new Date(b.scheduled_at) - new Date(a.scheduled_at));
  },
};

const mutations = {
  addComms(state, data) {
    const allComms = [
      ...state.communicationLogs,
      ...data.communicationLogs
    ];

    state.paginationPage++;

    if (data.communicationLogs.length < state.paginationSize) {
      state.showMoreCommsButton = false;
    }

    state.communicationLogs = allComms;
  },
  reset(state) {
    state.contactId = null
    state.communicationLogs = [];
    state.paginationPage = 1;
    state.showMoreCommsButton = true;
  },
  setActiveTextContactModalId(state, contactId) {
    state.contactId = contactId;
  }
};

const actions = {
  setup({commit, dispatch, state}, contactId) {
    // Make sure you can subscribe to more then one at a time
    if (state.contactId !== null && state.contactId !== contactId) {
      unsubscribeToChannel("activeTextContactModal", state.contactId);
    }

    commit('setActiveTextContactModalId', contactId);
    subscribeToChannel("activeTextContactModal", contactId);

    return dispatch('getCommLogs', contactId)
  },
  getCommLogs({commit, state}, contactId) {
    return api.clientStore.initActiveTextContactModal(contactId, state.paginationPage, state.paginationSize)
      .then((response) => {
        commit('addComms', response.data);
      });
  },
  tearDown({commit, state}) {
    if (state.contactId !== null) {
      unsubscribeToChannel("activeTextContactModal", state.contactId);
    }

    commit('reset');
  },
};

const activeTextContactModalStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default activeTextContactModalStore;
